import React from "react";
import { render } from "react-dom";
import "./style.css";

function exact_synonym_query (s) {
    var q = 'PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> ' +
    'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> ' +
    'PREFIX xsd: <http://www.w3.org/2001/XMLSchema#> ' +
    'PREFIX owl: <http://www.w3.org/2002/07/owl#> ' +
    'PREFIX meshv: <http://id.nlm.nih.gov/mesh/vocab#> ' +
    'PREFIX mesh: <http://id.nlm.nih.gov/mesh/> ' +
    'PREFIX mesh2020: <http://id.nlm.nih.gov/mesh/2020/> ' +
    'PREFIX mesh2019: <http://id.nlm.nih.gov/mesh/2019/> ' +
    'PREFIX mesh2018: <http://id.nlm.nih.gov/mesh/2018/> ' +
    'PREFIX : <urn:ex:> ' +
    'SELECT DISTINCT ?paLabel ' +
    'FROM <http://id.nlm.nih.gov/mesh> ' +
    'WHERE { ' +
    `VALUES ?n {"${s}"@en} . ` +

    '?s ?p ?n . ' +
    '?possible_concepts (:|!:){,3} ?s . ' +
    'BIND (?possible_concepts as ?new). ' +
    '?new (:|!:){,3} ?n. ' +
    '?new rdf:type meshv:TopicalDescriptor. ' +

    '?new meshv:pharmacologicalAction ?pa . ' +
    '?pa rdfs:label ?paLabel .} '

    var e = encodeURIComponent(q);
    return (e);
    }

// MESH literals seem to be consistently capitalized, so for our
// demo purposes, it's sufficient to just consistently capitalize
// the query (ie first letter is capitalized). The alternative solution
// is to do a case-insensitive search using FILTER, but this has some
// performance issues.
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

// Convert server response to a simple list, with an optional class
// for styling the resultant html
function make_synonyms_list (synonym_list) {
    var rows = [];
    if (synonym_list === "") {
        rows.push({text:"No pharmacological actions found", class: "h1"});
        return (rows);
    }
    for (const cls of synonym_list) {
        rows.push({text:cls.paLabel.value, class:"item"});
    }
    return (rows);
}

class Input extends React.Component {
  constructor(props) {
    super(props);

      this.state = {
          synonyms: null,
          active: (props.locked && props.active) || false,
          value: props.value || "",
          error: props.error || "",
          label: props.label || "Label"
      };
  }

  changeValue(event) {
    const value = event.target.value;
    this.setState({ value, error: "" });
  }

    handleKeyPress(event) {
        if (event.which === 13) {
            var t = exact_synonym_query(capitalize(this.state.value));
            fetch("https://keithflower.org:5000/with-cors/?query=" + t + "&inference=TRUE")
                .then (response => response.json())
                .then(data => {
                    var response = JSON.parse(data.stuff);
                    var synonyms = response.results.bindings;
                    var rows = make_synonyms_list(synonyms);
                    this.setState({
                         synonyms: rows});
                });
            event.preventDefault();
        }
    }

  render() {
    const { active, value, error, label } = this.state;
    const { predicted, locked } = this.props;
    const fieldClassName = `field ${(locked ? active : active || value) &&
      "active"} ${locked && !active && "locked"}`;

    return (
      <div className={fieldClassName}>
        {active &&
          value &&
          predicted &&
          predicted.includes(value) && <p className="predicted">{predicted}</p>}
        <input
          id={1}
          type="text"
          value={value}
          placeholder={label}
          onChange={this.changeValue.bind(this)}
          onKeyPress={this.handleKeyPress.bind(this)}
          onFocus={() => !locked && this.setState({ active: true })}
          onBlur={() => !locked && this.setState({ active: false })}
        />
        <label htmlFor={1} className={error && "error"}>
          {error || label}
        </label>
                       {
                    this.state.synonyms == null ?
                        <div></div>
                        :
                        <div>{this.state.synonyms.map((drug, index) => (
                                <div className={drug.class} key={index}>{drug.text}</div>
                        ))}
                    </div>
                }
      </div>
    );
  }
}

render (
  <Input
    id={1}
    label="Find pharmacological action(s) for..."
    predicted=""
    locked={false}
    active={false}
  />,
  document.getElementById("app")
);


